module.exports = __webpack_public_path__ + "static/media/logoListaDocente.ea55fcf5.svg";